import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class CreateMemberService {

  constructor(
    private httpClient: HttpClient,
    private common: DatabaseCacheService,
    private msalService: MsalService,
  ) { }

  createMember(postBody : any) {
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user!.idTokenClaims!['sub']);

    let headers = new HttpHeaders({'Content-Type': 'application/json'  })
      .set("loginUserId", loginUserId);

    let sectionId = this.common.getSelectedSection().sectionId;

    return this.httpClient.post(`${apiConfig.uri}/licence/${sectionId}/members`, postBody, {headers : headers});
  }

}
